<template>
  <v-data-table
    :headers="headers"
    :items="lols"
    sort-by="lolNumber"
    :search="search"
    class="elevation-1"
    v-model="selected"
    item-key="lolNumber"
    multi-sort
    :loading="loading"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-text-field
          flat
          solo
          prepend-icon="search"
          placeholder="Search"
          v-model="search"
          hide-details
          class="hidden-sm-and-down"
        ></v-text-field>

        <v-spacer></v-spacer>

        <v-bottom-sheet v-model="sheet" scrollable>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="checkRole(['ROLE_LFADMIN', 'ROLE_LFTECH'])"
              color="primary"
              dark class="mb-2"
              v-bind="attrs"
              v-on="on"
              @click="clearSheet()"
            >
              New LOL
            </v-btn>
          </template>

          <v-card>
            <v-tabs
              v-model="tab"
              centered
              fixed-tabs
              background-color="cyan"
              dark
              icons-and-text
            >
              <v-spacer></v-spacer>

              <v-tabs-slider color="yellow"></v-tabs-slider>
              <v-tab href="#tab-1">
                LOL
                <v-icon>mdi-tablet-cellphone</v-icon>
              </v-tab>

              <v-tab
                v-if="editedItem.unit.unitID && checkRole('lf')"
                href="#tab-2"
              >
                Unit
                <v-icon>mdi-briefcase-outline</v-icon>
              </v-tab>

              <v-tab
                v-if="!editedItem.unit.unitID && checkRole(['ROLE_LFADMIN', 'ROLE_LFTECH'])"
                href="#tab-2a"
                :disabled="!editedItem.lolID"
              >
                Add Unit
                <v-icon>mdi-plus</v-icon>
              </v-tab>

              <v-tab
                v-if="editedItem.unit.parts[0].partID && checkRole(['ROLE_LFADMIN', 'ROLE_LFTECH'])"
                href="#tab-3"
              >
                Parts
                <v-icon>mdi-memory</v-icon>
              </v-tab>

              <v-tab
                v-if="editedItem.unit.unitID && !editedItem.unit.parts[0].partID && checkRole(['ROLE_LFADMIN', 'ROLE_LFTECH'])"
                @click="editedItem.parts = true"
                href="#tab-3"
              >
                Add Parts
                <v-icon>mdi-plus</v-icon>
              </v-tab>

              <v-spacer></v-spacer>

              <v-btn
                class="align-self-center mr-4"
                icon
                dark
                fab
                @click="editModeToggle(true)"
                v-if="(!editMode && !editModeDealer) && checkRole(['ROLE_LFADMIN','ROLE_LFTECH', 'ROLE_DEALERADMIN'])"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              
              <v-btn
                class="align-self-center mr-4"
                icon
                dark
                fab
                @click="editModeToggle(false)"
                v-if="editMode || editModeDealer"
              >
                <v-icon>mdi-pencil-off</v-icon>
              </v-btn>

              <v-btn
                class="align-self-center mr-4"
                icon
                dark
                fab
                @click="close()"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-tabs>
            
            <v-card-text height="500">
              <v-tabs-items v-model="tab">
                <v-tab-item
                  value="tab-1"
                  eager
                >
                  <v-card flat>
                    <v-form clearable>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="6">
                            <v-text-field
                              v-model="editedItem.lolNumber"
                              label="LOL Number"
                              color="cyan"
                              :rules="rules.required"
                              required
                              hint="Required"
                              persistent-hint
                              :readonly="!editMode"
                            ></v-text-field>
                          </v-col>

                          <v-col cols="12" sm="6">
                            <v-text-field
                              v-model="editedItem.lolName"
                              label="LOL Nickname"
                              color="cyan"
                              :readonly="!editMode"
                            ></v-text-field>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col
                            cols="12"
                            sm="6"
                            v-if="checkRole('lf')"
                          >
                            <v-autocomplete
                              v-model="editedItem.customerID"
                              label="Dealer"
                              :items="dealers"
                              item-text="customerName"
                              item-value="customerID"
                              color="cyan"
                              item-color="cyan"
                              @change="refreshLocations(editedItem.customerID)"
                              :selected="editedItem.customerID"
                              :readonly="!editMode"
                            ></v-autocomplete>
                          </v-col>

                          <v-col cols="12" sm="6">
                            <v-autocomplete
                              v-model="editedItem.locationID"
                              label="Location"
                              :items="locations"
                              item-text="locationName"
                              item-value="locationID"
                              color="cyan"
                              item-color="cyan"
                              :selected="editedItem.locationID"
                              :disabled="!editedItem.customerID"
                              :readonly="!editMode"
                            ></v-autocomplete>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col
                            cols="12"
                            sm="6"
                          >
                            <v-text-field
                              v-if="checkRole('lf')"
                              v-model="editedItem.calibrationDateShow"
                              label="Next Calibration Date"
                              color="cyan"
                              readonly
                            >
                              <!-- <template v-slot:append-outer>
                                <v-tooltip top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      icon
                                      @click="openCalibrationDialog()"
                                      v-bind="attrs"
                                      v-on="on"
                                    >
                                      <v-icon>mdi-tools</v-icon>
                                    </v-btn>
                                  </template>
                                  <span>Perform Calibration</span>
                                </v-tooltip>
                              </template> -->
                            </v-text-field>

                            <v-text-field
                              v-else
                              v-model="editedItem.calibrationDateShow"
                              label="Next Calibration Date"
                              color="cyan"
                              readonly
                            ></v-text-field>
                          </v-col>

                          <v-col
                            cols="12"
                            sm="6"
                            v-if="checkRole('lf')"
                          >
                            <v-textarea
                              v-model="editedItem.lolNotes"
                              rows="2"
                              color="blue-grey"
                              :readonly="!editMode"
                              filled
                              auto-grow
                              background-color="orange lighten-4"
                            >
                              <template v-slot:label>
                                <div>
                                  LOL Notes <small>(LF Internal)</small>
                                </div>
                              </template>
                            </v-textarea>
                          </v-col>
                        </v-row>

                        <v-expansion-panels v-if="checkRole('lf')">
                          <v-expansion-panel>
                            <v-expansion-panel-header
                              color="cyan"
                              class="white--text"
                            >
                              <div>
                                Technical <small>(LF Internal)</small>
                              </div>
                              <template v-slot:actions>
                                <v-icon color="white">
                                  $expand
                                </v-icon>
                              </template>
                            </v-expansion-panel-header>

                            <v-expansion-panel-content>
                              <v-container class="py-6 px-0">
                                <v-row>
                                  <v-col
                                    cols="12"
                                    md="8"
                                  >
                                    <v-card class="mb-4">
                                      <v-card-title class="text-body-1 pb-0">
                                        Activity
                                      </v-card-title>
                                      <v-row>
                                        <v-col
                                          cols="12"
                                          sm="6"
                                        >
                                          <v-list dense>
                                            <v-list-item two-line>
                                              <v-list-item-avatar>
                                                <v-icon
                                                  class="grey"
                                                  dark
                                                >
                                                  mdi-power
                                                </v-icon>
                                              </v-list-item-avatar>
                                              <v-list-item-content>
                                                <v-list-item-title>Last Power On</v-list-item-title>
                                                <v-list-item-subtitle v-if="editedItem.lastPowerOn">{{ editedItem.lastPowerOnShow }}</v-list-item-subtitle>
                                                <v-list-item-subtitle v-else>-----</v-list-item-subtitle>
                                              </v-list-item-content>
                                            </v-list-item>

                                            <v-list-item two-line>
                                              <v-list-item-avatar>
                                                <v-icon
                                                  class="grey"
                                                  dark
                                                >
                                                  mdi-sync
                                                </v-icon>
                                              </v-list-item-avatar>
                                              <v-list-item-content>
                                                <v-list-item-title>Last Sync</v-list-item-title>
                                                <v-list-item-subtitle v-if="editedItem.lastSync">{{ editedItem.lastSyncShow }}</v-list-item-subtitle>
                                                <v-list-item-subtitle v-else>-----</v-list-item-subtitle>
                                              </v-list-item-content>
                                            </v-list-item>
                                          </v-list>
                                        </v-col>

                                        <v-col
                                          cols="12"
                                          sm="6"
                                        >
                                          <v-list dense>
                                            <v-list-item two-line>
                                              <v-list-item-avatar>
                                                <v-icon
                                                  class="grey"
                                                  dark
                                                >
                                                  mdi-ray-start-arrow
                                                </v-icon>
                                              </v-list-item-avatar>
                                              <v-list-item-content>
                                                <v-list-item-title>Commission Date</v-list-item-title>
                                                <v-list-item-subtitle v-if="editedItem.commissionDate">{{ editedItem.commissionDateShow }}</v-list-item-subtitle>
                                                <v-list-item-subtitle v-else>-----</v-list-item-subtitle>
                                              </v-list-item-content>
                                            </v-list-item>

                                            <v-list-item two-line>
                                              <v-list-item-avatar>
                                                <v-icon
                                                  class="grey"
                                                  dark
                                                >
                                                  mdi-ray-end
                                                </v-icon>
                                              </v-list-item-avatar>
                                              <v-list-item-content>
                                                <v-list-item-title>Decommission Date</v-list-item-title>
                                                <v-list-item-subtitle v-if="editedItem.decommissionDate">{{ editedItem.decommissionDateShow }}</v-list-item-subtitle>
                                                <v-list-item-subtitle v-else>-----</v-list-item-subtitle>
                                              </v-list-item-content>
                                              <v-list-item-action>
                                                <v-tooltip top>
                                                  <template v-slot:activator="{ on, attrs }">
                                                    <v-btn
                                                      icon
                                                      color="grey"
                                                      :disabled="editedItem.decommissionDate != null || !editMode"
                                                      @click="dialogDecommissionLol = true"
                                                      v-bind="attrs"
                                                      v-on="on"
                                                    >
                                                      <v-icon>mdi-robot-dead</v-icon>
                                                    </v-btn>
                                                  </template>
                                                  <span>Decommission LOL</span>
                                                </v-tooltip>
                                              </v-list-item-action>
                                            </v-list-item>
                                          </v-list>
                                        </v-col>
                                      </v-row>
                                    </v-card>
                                  </v-col>

                                  <v-col
                                    cols="12"
                                    md="4"
                                  >
                                    <v-card class="mb-4">
                                      <v-card-title class="text-body-1 pb-0">
                                        Software
                                      </v-card-title>
                                      <v-row>
                                        <v-col
                                          cols="12"
                                        >
                                          <v-list dense>
                                            <v-list-item two-line>
                                              <v-list-item-avatar>
                                                <v-icon
                                                  class="grey"
                                                  dark
                                                >
                                                  mdi-database
                                                </v-icon>
                                              </v-list-item-avatar>
                                              <v-list-item-content>
                                                <v-list-item-title>Backend Version</v-list-item-title>
                                                <v-list-item-subtitle>{{ editedItem.backendVersion }}</v-list-item-subtitle>
                                              </v-list-item-content>
                                            </v-list-item>

                                            <v-list-item two-line>
                                              <v-list-item-avatar>
                                                <v-icon
                                                  class="grey"
                                                  dark
                                                >
                                                  mdi-tablet
                                                </v-icon>
                                              </v-list-item-avatar>
                                              <v-list-item-content>
                                                <v-list-item-title>Frontend Version</v-list-item-title>
                                                <v-list-item-subtitle>{{ editedItem.frontendVersion }}</v-list-item-subtitle>
                                              </v-list-item-content>
                                            </v-list-item>
                                          </v-list>
                                        </v-col>
                                      </v-row>
                                    </v-card>
                                  </v-col>
                                </v-row>

                                <v-row>
                                  <v-col
                                    cols="12"
                                    md="8"
                                  >
                                    <v-card class="mb-4">
                                      <v-card-title class="text-body-1 pb-0">
                                        Network
                                      </v-card-title>
                                      <v-row>
                                        <v-col
                                          cols="12"
                                          sm="6"
                                        >
                                          <v-list dense>
                                            <v-list-item two-line>
                                              <v-list-item-avatar>
                                                <v-icon
                                                  class="grey"
                                                  dark
                                                >
                                                  mdi-wifi
                                                </v-icon>
                                              </v-list-item-avatar>
                                              <v-list-item-content>
                                                <v-list-item-title>Private IP</v-list-item-title>
                                                <v-list-item-subtitle>{{ editedItem.privateIP }}</v-list-item-subtitle>
                                              </v-list-item-content>
                                            </v-list-item>

                                            <v-list-item two-line>
                                              <v-list-item-avatar>
                                                <v-icon
                                                  class="grey"
                                                  dark
                                                >
                                                  mdi-web
                                                </v-icon>
                                              </v-list-item-avatar>
                                              <v-list-item-content>
                                                <v-list-item-title>Public IP</v-list-item-title>
                                                <v-list-item-subtitle>{{ editedItem.publicIP }}</v-list-item-subtitle>
                                              </v-list-item-content>
                                            </v-list-item>
                                          </v-list>
                                        </v-col>

                                        <v-col
                                          cols="12"
                                          sm="6"
                                        >
                                          <v-list dense>
                                            <v-list-item two-line>
                                              <v-list-item-avatar>
                                                <v-icon
                                                  class="grey"
                                                  dark
                                                >
                                                  mdi-access-point
                                                </v-icon>
                                              </v-list-item-avatar>
                                              <v-list-item-content>
                                                <v-list-item-title>Gateway IP</v-list-item-title>
                                                <v-list-item-subtitle>{{ editedItem.gatewayIP }}</v-list-item-subtitle>
                                              </v-list-item-content>
                                            </v-list-item>

                                            <v-list-item two-line>
                                              <v-list-item-avatar>
                                                <v-icon
                                                  class="grey"
                                                  dark
                                                >
                                                  mdi-access-point-network
                                                </v-icon>
                                              </v-list-item-avatar>
                                              <v-list-item-content>
                                                <v-list-item-title>Gateway MAC</v-list-item-title>
                                                <v-list-item-subtitle>{{ editedItem.gatewayMAC }}</v-list-item-subtitle>
                                              </v-list-item-content>
                                            </v-list-item>
                                          </v-list>
                                        </v-col>
                                      </v-row>
                                    </v-card>
                                  </v-col>
                                </v-row>

                                <v-row dense>
                                  <v-col
                                    cols="12"
                                    sm="6"
                                    md="4"
                                  >
                                    <v-switch
                                      v-model="editedItem.unaccredited"
                                      label="Unaccredited"
                                      color="cyan"
                                      inset
                                      :readonly="!editMode"
                                    ></v-switch>
                                  </v-col>
                                </v-row>

                                <v-row dense>
                                  <v-col
                                    cols="12"
                                    sm="6"
                                    md="4"
                                  >
                                    <v-switch
                                      v-model="editedItem.debugMode"
                                      label="Debug Mode"
                                      color="cyan"
                                      inset
                                      :readonly="!editMode"
                                      disabled
                                    ></v-switch>
                                  </v-col>
                                </v-row>

                                <v-row dense>
                                  <v-col
                                    cols="12"
                                    sm="6"
                                    md="4"
                                  >
                                    <v-switch
                                      v-model="editedItem.forceClearSync"
                                      label="Force Clear & Sync"
                                      color="cyan"
                                      inset
                                      :readonly="!editMode"
                                    ></v-switch>
                                  </v-col>
                                </v-row>
                              </v-container>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </v-container>

                      <v-container>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            plain
                            @click="close"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            color="cyan"
                            dark
                            @click="save"
                          >
                            Save
                          </v-btn>
                        </v-card-actions>
                      </v-container>
                    </v-form>
                  </v-card>
                </v-tab-item>

                <v-tab-item
                  v-if="editedItem.unit.unitID && checkRole('lf')"
                  value="tab-2"
                >
                  <v-card flat>
                    <v-form clearable>
                      <v-container>
                        <v-row>
                          <v-col
                            cols="12"
                            sm="6"
                          >
                            <v-text-field
                              v-model="editedItem.unit.unitNumber"
                              label="Unit Number"
                              color="cyan"
                              :rules="rules.required"
                              required
                              hint="Required"
                              persistent-hint
                              :readonly="!editMode"
                            ></v-text-field>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col
                            cols="12"
                            sm="6"
                          >
                            <v-textarea
                              v-model="editedItem.unit.unitNotes"
                              rows="2"
                              color="blue-grey"
                              :readonly="!editMode"
                              filled
                              auto-grow
                              background-color="orange lighten-4"
                            >
                              <template v-slot:label>
                                Unit Notes
                              </template>
                            </v-textarea>
                          </v-col>
                        </v-row>

                        <v-expansion-panels>
                          <v-expansion-panel>
                            <v-expansion-panel-header
                              color="cyan"
                              class="white--text"
                            >
                              Technical
                              <template v-slot:actions>
                                <v-icon color="white">
                                  $expand
                                </v-icon>
                              </template>
                            </v-expansion-panel-header>

                            <v-expansion-panel-content>
                              <v-container>
                                <v-row>
                                  <v-col
                                    cols="12"
                                    md="8"
                                  >
                                    <v-card class="mb-4">
                                      <v-card-title class="text-body-1 pb-0">
                                        Activity
                                      </v-card-title>
                                      <v-row>
                                        <v-col
                                          cols="12"
                                          sm="6"
                                        >
                                          <v-list dense>
                                            <v-list-item two-line>
                                              <v-list-item-avatar>
                                                <v-icon
                                                  class="grey"
                                                  dark
                                                >
                                                  mdi-briefcase-outline
                                                </v-icon>
                                              </v-list-item-avatar>
                                              <v-list-item-content>
                                                <v-list-item-title>Manufacture Date</v-list-item-title>
                                                <v-list-item-subtitle v-if="editedItem.unit.manufactureDate">{{ editedItem.unit.manufactureDateShow }}</v-list-item-subtitle>
                                                <v-list-item-subtitle v-else>-----</v-list-item-subtitle>
                                              </v-list-item-content>
                                              <v-list-item-action>
                                                <v-tooltip top>
                                                  <template v-slot:activator="{ on, attrs }">
                                                    <v-btn
                                                      icon
                                                      @click="dialogManufactureUnit = true"
                                                      :disabled="editedItem.unit.manufactureDate != null || !editMode"
                                                      v-bind="attrs"
                                                      v-on="on"
                                                    >
                                                      <v-icon>mdi-briefcase-check</v-icon>
                                                    </v-btn>
                                                  </template>
                                                  <span>Mark as Manufactured</span>
                                                </v-tooltip>
                                              </v-list-item-action>
                                            </v-list-item>
                                          </v-list>
                                        </v-col>

                                        <v-col
                                          cols="12"
                                          sm="6"
                                        >
                                          <v-list dense>
                                            <v-list-item two-line>
                                              <v-list-item-avatar>
                                                <v-icon
                                                  class="grey"
                                                  dark
                                                >
                                                  mdi-ray-start-arrow
                                                </v-icon>
                                              </v-list-item-avatar>
                                              <v-list-item-content>
                                                <v-list-item-title>Commission Date</v-list-item-title>
                                                <v-list-item-subtitle v-if="editedItem.unit.commissionDate">{{ editedItem.unit.commissionDateShow }}</v-list-item-subtitle>
                                                <v-list-item-subtitle v-else>-----</v-list-item-subtitle>
                                              </v-list-item-content>
                                            </v-list-item>

                                            <v-list-item two-line>
                                              <v-list-item-avatar>
                                                <v-icon
                                                  class="grey"
                                                  dark
                                                >
                                                  mdi-ray-end
                                                </v-icon>
                                              </v-list-item-avatar>
                                              <v-list-item-content>
                                                <v-list-item-title>Decommission Date</v-list-item-title>
                                                <v-list-item-subtitle v-if="editedItem.unit.decommissionDate">{{ editedItem.unit.decommissionDateShow }}</v-list-item-subtitle>
                                                <v-list-item-subtitle v-else>-----</v-list-item-subtitle>
                                              </v-list-item-content>
                                              <!-- <v-list-item-action>
                                                <v-tooltip top>
                                                  <template v-slot:activator="{ on, attrs }">
                                                    <v-btn
                                                      icon
                                                      color="grey"
                                                      :disabled="editedItem.decommissionDate != null || !editMode"
                                                      @click="dialogDecommissionLol = true"
                                                      v-bind="attrs"
                                                      v-on="on"
                                                    >
                                                      <v-icon>mdi-robot-dead</v-icon>
                                                    </v-btn>
                                                  </template>
                                                  <span>Decommission LOL</span>
                                                </v-tooltip>
                                              </v-list-item-action> -->
                                            </v-list-item>
                                          </v-list>
                                        </v-col>
                                      </v-row>
                                    </v-card>
                                  </v-col>
                                </v-row>
                              </v-container>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </v-container>

                      <v-container>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            plain
                            @click="close"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            color="cyan"
                            dark
                            @click="saveUnit"
                          >
                            Save
                          </v-btn>
                        </v-card-actions>
                      </v-container>
                    </v-form>
                  </v-card>
                </v-tab-item>

                <v-tab-item
                  v-if="!editedItem.unit.unitID && checkRole(['ROLE_LFADMIN', 'ROLE_LFTECH'])"
                  value="tab-2a"
                >
                  <v-card flat>
                    <v-form clearable>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="6">
                            <v-btn
                              block
                              outlined
                              height="100"
                              color="cyan"
                              @click="unassignedUnitDialog"
                            >
                              <v-icon left>
                                mdi-briefcase-search-outline
                              </v-icon>
                              Unassigned Unit
                            </v-btn>
                          </v-col>

                          <v-col cols="12" sm="6">
                            <v-btn
                              block
                              outlined
                              color="cyan"
                              height="100"
                              @click="newUnitDialog"
                            >
                              <v-icon left>
                                mdi-briefcase-plus-outline
                              </v-icon>
                              New Unit
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-container>

                      <v-container>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            plain
                            @click="close"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            color="cyan"
                            dark
                            @click="saveUnit"
                          >
                            Save
                          </v-btn>
                        </v-card-actions>
                      </v-container>
                    </v-form>
                  </v-card>
                </v-tab-item>

                <v-tab-item
                  v-if="editedItem.unit.unitID && checkRole(['ROLE_LFADMIN', 'ROLE_LFTECH'])"
                  value="tab-3"
                  eager
                >
                  <v-card flat>
                    <v-form clearable>
                      <v-container>
                        <v-row>
                          <v-col
                            cols="11"
                          >
                            <v-row class="mb-2">
                              <v-col
                                cols="12"
                                class="pb-0"
                                v-for="(part, index) in editedItem.unit.parts"
                                :key="part.partID"
                              >
                                <v-card v-if="part.partID">
                                  <v-toolbar
                                    dense
                                    dark
                                    color="cyan"
                                  >
                                    <v-toolbar-title>
                                      <v-btn
                                        text
                                        dark
                                        depressed
                                        @click="showPart(part.partID)"
                                      >
                                        {{ part.partName ? part.partName : part.partString }}
                                      </v-btn>
                                    </v-toolbar-title>

                                    <v-spacer></v-spacer>

                                    <!-- <v-slide-x-transition>
                                      <div v-show="partShow == part.partID && partEdit != part.partID">
                                        <v-tooltip bottom>
                                          <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                              v-show="partShow == part.partID && partEdit != part.partID"
                                              fab
                                              icon
                                              small
                                              @click="deletePartDialog(index)"
                                              v-bind="attrs"
                                              v-on="on"
                                            >
                                              <v-icon>
                                                mdi-trash-can
                                              </v-icon>
                                            </v-btn>
                                          </template>
                                          <span>Delete</span>
                                        </v-tooltip>
                                      </div>
                                    </v-slide-x-transition> -->

                                    <v-slide-x-transition>
                                      <div v-show="partShow == part.partID && partEdit != part.partID">
                                        <v-tooltip bottom>
                                          <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                              v-show="partShow == part.partID && partEdit != part.partID"
                                              fab
                                              icon
                                              small
                                              @click="editPart(index)"
                                              v-bind="attrs"
                                              v-on="on"
                                            >
                                              <v-icon>
                                                mdi-pencil
                                              </v-icon>
                                            </v-btn>
                                          </template>
                                          <span>Edit</span>
                                        </v-tooltip>
                                      </div>
                                    </v-slide-x-transition>

                                    <v-slide-x-reverse-transition>
                                      <div v-show="partShow == part.partID && partEdit == part.partID">
                                        <v-tooltip bottom>
                                          <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                              fab
                                              icon
                                              small
                                              @click="undoPart(index)"
                                              v-bind="attrs"
                                              v-on="on"
                                            >
                                              <v-icon>
                                                mdi-undo-variant
                                              </v-icon>
                                            </v-btn>
                                          </template>
                                          <span>Undo</span>
                                        </v-tooltip>
                                      </div>
                                    </v-slide-x-reverse-transition>

                                    <v-slide-x-reverse-transition>
                                      <div v-show="partShow == part.partID && partEdit == part.partID">
                                        <v-tooltip bottom>
                                          <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                              v-show="partShow == part.partID && partEdit == part.partID"
                                              fab
                                              icon
                                              small
                                              @click="savePart(index)"
                                              v-bind="attrs"
                                              v-on="on"
                                            >
                                              <v-icon>
                                                mdi-check
                                              </v-icon>
                                            </v-btn>
                                          </template>
                                          <span>Save</span>
                                        </v-tooltip>
                                      </div>
                                    </v-slide-x-reverse-transition>

                                    <v-btn
                                      fab
                                      icon
                                      small
                                      @click="showPart(part.partID)"
                                    >
                                      <v-icon v-if="partShow != part.partID">mdi-chevron-down</v-icon>
                                      <v-icon v-else>mdi-chevron-up</v-icon>
                                    </v-btn>
                                  </v-toolbar>

                                  <v-expand-transition>
                                    <div v-show="partShow == part.partID">
                                      <v-card-text>
                                        <v-container>
                                          <v-row dense>
                                            <v-col
                                              cols="12"
                                              sm="5"
                                            >
                                              <v-text-field
                                                v-model="part.partName"
                                                label="Name"
                                                color="cyan"
                                                :readonly="partEdit != part.partID"
                                                dense
                                              ></v-text-field>
                                            </v-col>

                                            <v-col
                                              cols="12"
                                              sm="5"
                                            >
                                              <v-text-field
                                                v-model="part.partString"
                                                label="String"
                                                color="cyan"
                                                :readonly="partEdit != part.partID"
                                                dense
                                              ></v-text-field>
                                            </v-col>

                                            <v-col
                                              cols="12"
                                              sm="2"
                                            >
                                              <v-switch
                                                class="mt-0"
                                                v-model="part.primary"
                                                label="Primary"
                                                inset
                                                color="cyan"
                                                :readonly="partEdit != part.partID"
                                                dense
                                              ></v-switch>
                                            </v-col>
                                          </v-row>

                                          <v-row dense>
                                            <v-col
                                              cols="12"
                                              sm="4"
                                            >
                                              <v-text-field
                                                v-model="part.partMake"
                                                label="Make"
                                                color="cyan"
                                                :readonly="partEdit != part.partID"
                                                dense
                                              ></v-text-field>
                                            </v-col>

                                            <v-col
                                              cols="12"
                                              sm="4"
                                            >
                                              <v-text-field
                                                v-model="part.partModel"
                                                label="Model"
                                                color="cyan"
                                                :readonly="partEdit != part.partID"
                                                dense
                                              ></v-text-field>
                                            </v-col>

                                            <v-col
                                              cols="12"
                                              sm="4"
                                            >
                                              <v-text-field
                                                v-model="part.partSN"
                                                label="SN"
                                                color="cyan"
                                                :readonly="partEdit != part.partID"
                                                dense
                                              ></v-text-field>
                                            </v-col>
                                          </v-row>

                                          <v-row dense>
                                            <v-col
                                              cols="12"
                                              sm="6"
                                            >
                                              <v-text-field
                                                v-model="part.curves[0].curveM"
                                                label="Curve M"
                                                color="cyan"
                                                :readonly="partEdit != part.partID"
                                                dense
                                              ></v-text-field>
                                            </v-col>

                                            <v-col
                                              cols="12"
                                              sm="6"
                                            >
                                              <v-text-field
                                                v-model="part.curves[0].curveB"
                                                label="Curve B"
                                                color="cyan"
                                                :readonly="partEdit != part.partID"
                                                dense
                                              >
                                                <template v-slot:append-outer>
                                                  <v-tooltip top>
                                                    <template v-slot:activator="{ on, attrs }">
                                                      <v-btn
                                                        icon
                                                        @click="openCurveHistoryDialog(index)"
                                                        v-bind="attrs"
                                                        v-on="on"
                                                      >
                                                        <v-icon>mdi-history</v-icon>
                                                      </v-btn>
                                                    </template>
                                                    <span>View Curve History</span>
                                                  </v-tooltip>
                                                </template>
                                              </v-text-field>
                                            </v-col>
                                          </v-row>

                                          <v-row dense>
                                            <v-col
                                              cols="12"
                                              sm="6"
                                            >
                                              <v-textarea
                                                v-model="part.partNotes"
                                                rows="2"
                                                color="blue-grey"
                                                :readonly="partEdit != part.partID"
                                                filled
                                                auto-grow
                                                background-color="orange lighten-4"
                                                dense
                                              >
                                                <template v-slot:label>
                                                  Part Notes
                                                </template>
                                              </v-textarea>
                                            </v-col>
                                          </v-row>

                                          <v-row dense>
                                            <v-col
                                              cols="12"
                                            >
                                              <v-expansion-panels>
                                                <v-expansion-panel>
                                                  <v-expansion-panel-header
                                                    color="cyan"
                                                    class="white--text"
                                                  >
                                                    Technical
                                                    <template v-slot:actions>
                                                      <v-icon color="white">
                                                        $expand
                                                      </v-icon>
                                                    </template>
                                                  </v-expansion-panel-header>

                                                  <v-expansion-panel-content>
                                                    <v-container>
                                                      <v-row dense class="mt-2">
                                                        <v-col
                                                          cols="12"
                                                          sm="6"
                                                        >
                                                          <v-text-field
                                                            v-model="part.installDateShow"
                                                            label="Install Date"
                                                            color="cyan"
                                                            disabled
                                                            dense
                                                          ></v-text-field>
                                                        </v-col>
                                                      </v-row>

                                                      <v-row dense>
                                                        <v-col
                                                          cols="12"
                                                          sm="6"
                                                        >
                                                          <v-text-field
                                                            v-model="part.commissionDateShow"
                                                            label="Commission Date"
                                                            color="cyan"
                                                            disabled
                                                            dense
                                                          ></v-text-field>
                                                        </v-col>

                                                        <v-col
                                                          cols="12"
                                                          sm="6"
                                                        >
                                                          <v-text-field
                                                            v-model="part.decommissionDateShow"
                                                            label="Decommission Date"
                                                            color="cyan"
                                                            disabled
                                                            dense
                                                          ></v-text-field>
                                                        </v-col>
                                                      </v-row>
                                                    </v-container>
                                                  </v-expansion-panel-content>
                                                </v-expansion-panel>
                                              </v-expansion-panels>
                                            </v-col>
                                          </v-row>
                                        </v-container>
                                      </v-card-text>
                                    </div>
                                  </v-expand-transition>
                                </v-card>
                              </v-col>
                            </v-row>
                          </v-col>

                          <v-col
                            cols="1"
                          >
                            <v-row>
                              <v-col cols="12">
                                <v-btn
                                  icon
                                  elevation="2"
                                  fab
                                  @click="addPartDialog()"
                                >
                                  <v-icon>
                                    mdi-plus
                                  </v-icon>
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-form>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-card-text>
          </v-card>
        </v-bottom-sheet>

        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="headline">
              Are you sure you want to delete this LOL?
            </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                text
                @click="closeDelete"
              >
                Cancel
              </v-btn>
              <v-btn
                color="error"
                dark
                @click="deleteItemConfirm"
              >
                Delete
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogNewUnit" max-width="500px">
          <v-card>
            <v-card-title class="headline">
              Create a New Unit
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row dense>
                  <v-col cols="12">
                    <v-text-field
                      v-model="unitCreate.unitNumber"
                      label="Unit Number"
                      color="cyan"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col cols="12">
                    <v-textarea
                      v-model="unitCreate.unitNotes"
                      rows="2"
                      color="blue-grey"
                      filled
                      auto-grow
                      background-color="orange lighten-4"
                    >
                      <template v-slot:label>
                        Unit Notes
                      </template>
                    </v-textarea>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="newUnitDialogClose">Cancel</v-btn>
              <v-btn color="cyan" dark @click="newUnit">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogUnassignedUnit" max-width="500px">
          <v-card>
            <v-card-title class="headline">
              Select an Unassigned Unit
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row dense>
                  <v-col cols="12">
                    <v-autocomplete
                      v-model="unitUpdate"
                      label="Unit"
                      :items="units"
                      item-text="unitNumber"
                      item-value="unitID"
                      color="cyan"
                      item-color="cyan"
                      return-object
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="unassignedUnitDialogClose">Cancel</v-btn>
              <v-btn
                color="cyan"
                dark
                @click="unassignedUnit"
              >
                OK
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogDeletePart" max-width="500px">
          <v-card>
            <v-card-title class="headline">
              Are you sure you want to delete this part?
            </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                text
                @click="deletePartDialogClose"
              >
                Cancel
              </v-btn>
              <v-btn
                color="error"
                dark
                @click="destroyPart"
              >
                Delete
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogAddPart" max-width="800px">
          <v-card>
            <v-card-title class="headline">
              Add Part
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row dense>
                  <v-col cols="12" sm="5">
                    <v-text-field
                      v-model="partCreate.partName"
                      label="Part Name"
                      color="cyan"
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="5">
                    <v-text-field
                      v-model="partCreate.partString"
                      label="Part String"
                      color="cyan"
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="2">
                    <v-switch
                      v-model="partCreate.primary"
                      label="Primary"
                      inset
                      color="cyan"
                    ></v-switch>
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col cols="12" sm="4">
                    <v-text-field
                      v-model="partCreate.partMake"
                      label="Make"
                      color="cyan"
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="4">
                    <v-text-field
                      v-model="partCreate.partModel"
                      label="Model"
                      color="cyan"
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="4">
                    <v-text-field
                      v-model="partCreate.partSN"
                      label="SN"
                      color="cyan"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="partCreate.curve.curveM"
                      label="Curve M"
                      color="cyan"
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="partCreate.curve.curveB"
                      label="Curve B"
                      color="cyan"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col cols="12">
                    <v-textarea
                      v-model="partCreate.partNotes"
                      rows="2"
                      color="blue-grey"
                      filled
                      auto-grow
                      background-color="orange lighten-4"
                    >
                      <template v-slot:label>
                        Part Notes
                      </template>
                    </v-textarea>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="addPartDialogClose">Cancel</v-btn>
              <v-btn color="cyan" dark @click="addPart">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogCalibration" max-width="500px">
          <v-card>
            <v-card-title class="headline">
              Perform Calibration

              <v-spacer></v-spacer>

              <v-btn
                icon
                v-if="calibrationStep != 'initial'"
                @click="calibrationStep = 'initial'"
              >
                <v-icon>mdi-restart</v-icon>
              </v-btn>

              <v-btn
                icon
                @click="dialogCalibration = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-fade-transition hide-on-leave>
                  <div v-show="calibrationStep == 'initial'">
                    <v-row>
                      <v-col cols="12" sm="6">
                        <v-btn
                          block
                          outlined
                          height="100"
                          color="cyan"
                          @click="calibrationStep = 'keep'"
                        >
                          <v-icon left>
                            mdi-briefcase-check-outline
                          </v-icon>
                          Keep Unit
                        </v-btn>
                      </v-col>

                      <v-col cols="12" sm="6">
                        <v-btn
                          block
                          outlined
                          color="cyan"
                          height="100"
                          @click="calibrationStep = 'change'"
                        >
                          <v-icon left>
                            mdi-briefcase-edit-outline
                          </v-icon>
                          Change Unit
                        </v-btn>
                      </v-col>
                    </v-row>
                  </div>
                </v-fade-transition>

                <v-fade-transition hide-on-leave>
                  <div v-show="calibrationStep == 'keep'">
                    <v-row>
                      <v-col
                        cols="12"
                      >
                        Are you ready to complete this calibration?<br />
                        (Assigned unit will stay the same)
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12">
                        <v-textarea
                          v-model="calibrationData.calibrationNotes"
                          rows="2"
                          color="blue-grey"
                          filled
                          auto-grow
                          background-color="orange lighten-4"
                        >
                          <template v-slot:label>
                            Calibration Notes
                          </template>
                        </v-textarea>
                      </v-col>
                    </v-row>
                  </div>
                </v-fade-transition>

                <v-fade-transition hide-on-leave>
                  <div v-show="calibrationStep == 'change'">
                    <v-row>
                      <v-col cols="12" sm="6">
                        <v-btn
                          block
                          outlined
                          height="100"
                          color="cyan"
                          @click="calibrationStep = 'changeUnassigned'"
                        >
                          <v-icon left>
                            mdi-briefcase-search-outline
                          </v-icon>
                          Unassigned Unit
                        </v-btn>
                      </v-col>

                      <v-col cols="12" sm="6">
                        <v-btn
                          block
                          outlined
                          color="cyan"
                          height="100"
                          @click="calibrationStep = 'changeNew'"
                        >
                          <v-icon left>
                            mdi-briefcase-plus-outline
                          </v-icon>
                          New Unit
                        </v-btn>
                      </v-col>
                    </v-row>
                  </div>
                </v-fade-transition>

                <v-fade-transition hide-on-leave>
                  <div v-show="calibrationStep == 'changeUnassigned'">
                    <v-row>
                      <v-col cols="12">
                        <v-autocomplete
                          v-model="unitCalibration"
                          label="Unit"
                          :items="units"
                          item-text="unitNumber"
                          item-value="unitID"
                          color="cyan"
                          item-color="cyan"
                          return-object
                        ></v-autocomplete>
                      </v-col>
                    </v-row>
                  </div>
                </v-fade-transition>

                <v-fade-transition hide-on-leave>
                  <div v-show="calibrationStep == 'changeNew'">
                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          v-model="unitCalibration.unitNumber"
                          label="Unit Number"
                          color="cyan"
                          required
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12">
                        <v-textarea
                          v-model="unitCalibration.unitNotes"
                          rows="2"
                          color="blue-grey"
                          filled
                          auto-grow
                          background-color="orange lighten-4"
                        >
                          <template v-slot:label>
                            Unit Notes
                          </template>
                        </v-textarea>
                      </v-col>
                    </v-row>
                  </div>
                </v-fade-transition>

                <v-fade-transition hide-on-leave>
                  <div v-show="calibrationStep == 'changeUnassignedConfirm' || calibrationStep == 'changeNewConfirm'">
                    <v-row>
                      <v-col cols="12">
                        Are you ready to complete this calibration?
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="6" v-if="editedItem.unitShow">
                        <v-row>
                          <v-col cols="12">
                            Previous Unit:
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col cols="12">
                            <v-card class="px-4">
                              <v-row>
                                <v-col cols="12">
                                  <v-text-field
                                    v-model="editedItem.unit.unitNumber"
                                    label="Unit Number"
                                    class="pt-4"
                                    color="cyan"
                                    readonly
                                    dense
                                  ></v-text-field>
                                </v-col>
                              </v-row>

                              <v-row>
                                <v-col cols="12">
                                  <v-textarea
                                    v-model="editedItem.unit.unitNotes"
                                    rows="2"
                                    color="blue-grey"
                                    filled
                                    auto-grow
                                    background-color="orange lighten-4"
                                    readonly
                                    dense
                                  >
                                    <template v-slot:label>
                                      Unit Notes
                                    </template>
                                  </v-textarea>
                                </v-col>
                              </v-row>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-col>

                      <v-col cols="6">
                        <v-row>
                          <v-col cols="12">
                            New Unit:
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col cols="12">
                            <v-card class="px-4">
                              <v-row>
                                <v-col cols="12">
                                  <v-text-field
                                    v-model="unitCalibration.unitNumber"
                                    label="Unit Number"
                                    class="pt-4"
                                    color="cyan"
                                    readonly
                                    dense
                                  ></v-text-field>
                                </v-col>
                              </v-row>

                              <v-row>
                                <v-col cols="12">
                                  <v-textarea
                                    v-model="unitCalibration.unitNotes"
                                    rows="2"
                                    color="blue-grey"
                                    filled
                                    auto-grow
                                    background-color="orange lighten-4"
                                    readonly
                                    dense
                                  >
                                    <template v-slot:label>
                                      Unit Notes
                                    </template>
                                  </v-textarea>
                                </v-col>
                              </v-row>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12">
                        <v-textarea
                          v-model="calibrationData.calibrationNotes"
                          rows="2"
                          color="blue-grey"
                          filled
                          auto-grow
                          background-color="orange lighten-4"
                        >
                          <template v-slot:label>
                            Calibration Notes
                          </template>
                        </v-textarea>
                      </v-col>
                    </v-row>
                  </div>
                </v-fade-transition>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn
                v-if="calibrationStep == 'changeUnassigned'"
                class="mb-2"
                color="cyan"
                dark
                @click="calibrationStep = 'changeUnassignedConfirm'"
              >
                Continue
              </v-btn>

              <v-btn
                v-if="calibrationStep == 'changeNew'"
                class="mb-2"
                color="cyan"
                dark
                @click="calibrationStep = 'changeNewConfirm'"
              >
                Continue
              </v-btn>

              <v-btn
                v-if="calibrationStep == 'keep' || calibrationStep == 'changeUnassignedConfirm' || calibrationStep == 'changeNewConfirm'"
                class="mb-2"
                color="cyan"
                dark
                @click="performCalibration()"
              >
                Finish
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogDecommissionLol" max-width="500px">
          <v-card>
            <v-card-title class="headline" style="word-break: normal">
              Are you sure you want to decommission this LOL?
            </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                text
                @click="dialogDecommissionLol = false"
              >
                Cancel
              </v-btn>
              <v-btn
                color="error"
                dark
                @click="decommissionLol()"
              >
                Decommission
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogManufactureUnit" max-width="500px">
          <v-card>
            <v-card-title class="headline" style="word-break: normal">
              Are you sure you want to mark this Unit as manufactured?
            </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                text
                @click="dialogManufactureUnit = false"
              >
                Cancel
              </v-btn>
              <v-btn
                color="cyan"
                dark
                @click="manufactureUnit()"
              >
                Manufacture
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogCurveHistory" max-width="500px">
          <v-card>
            <v-card-title class="headline" style="word-break: normal">
              Curve History

              <v-spacer></v-spacer>

              <v-btn
                icon
                @click="dialogCurveHistory = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>

            <v-card-text>
              <v-row class="mt-2">
                <v-col
                  cols="12"
                  v-for="curve in editedItem.unit.parts[editedPartIndex].curves"
                  :key="curve.curveID"
                >
                  <v-row>
                    <v-col cols="6">
                      <v-text-field
                        v-model="curve.createdAtShow"
                        label="Created At"
                        color="cyan"
                        readonly
                        dense
                      ></v-text-field>
                    </v-col>

                    <v-col cols="3">
                      <v-text-field
                        v-model="curve.curveM"
                        label="Curve M"
                        color="cyan"
                        readonly
                        dense
                      ></v-text-field>
                    </v-col>

                    <v-col cols="3">
                      <v-text-field
                        v-model="curve.curveB"
                        label="Curve B"
                        color="cyan"
                        readonly
                        dense
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <v-divider></v-divider>
    </template>

    <template v-slot:item.lolNumber="props">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <span
            class="subtitle-1"
            style="border-bottom: 1px dashed #111; cursor: pointer;"
            @click="editItem(props.item)"
            v-bind="attrs"
            v-on="on"
          >
            {{ props.item.lolNumber }}
          </span>
        </template>
        <span>View LOL</span>
      </v-tooltip>

      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="ml-2"
            icon
            v-bind="attrs"
            v-on="on"
            @click="$router.push($route.path + '/certificates?lolid=' + props.item.lolID);"
          >
            <v-icon>
              mdi-location-enter
            </v-icon>
          </v-btn>
        </template>
        <span>Go to Certificates</span>
      </v-tooltip>
    </template>

    <template v-slot:item.actions="{ item }">
      <v-menu offset-y transition="slide-y-transition">
        <template v-slot:activator="{ on: menu, attrs }">
          <v-tooltip top>
            <template v-slot:activator="{ on: tooltip }">
              <v-btn
                color="black"
                icon
                v-bind="attrs"
                v-on="{ ...tooltip, ...menu }"
              >
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <span>Actions</span>
          </v-tooltip>
        </template>
        <v-list>
          <v-list-item @click="$router.push($route.path + '/certificates?lolid=' + item.lolID);">
            <v-list-item-action class="mr-4">
              <v-icon color="">mdi-certificate-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Certificates</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <!-- <v-list-item
            v-if="checkRole('ROLE_LFADMIN')"
            @click="$router.push($route.path + '/calibrations?lolid=' + item.lolID);"
          >
            <v-list-item-action class="mr-4">
              <v-icon color="">mdi-wrench-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Calibrations</v-list-item-title>
            </v-list-item-content>
          </v-list-item> -->
          <!-- <v-list-item
            v-if="checkRole('ROLE_LFADMIN')"
            @click="$router.push($route.path + '/validations?lolid=' + item.lolID);"
          >
            <v-list-item-action class="mr-4">
              <v-icon color="">mdi-cloud-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Validations</v-list-item-title>
            </v-list-item-content>
          </v-list-item> -->
          <v-list-item @click="editItem(item)">
            <v-list-item-action class="mr-4">
              <v-icon>mdi-magnify</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>View</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <!-- <v-list-item @click="deleteItem(item)">
            <v-list-item-action class="mr-4">
              <v-icon color="red">mdi-trash-can-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Delete</v-list-item-title>
            </v-list-item-content>
          </v-list-item> -->
        </v-list>
      </v-menu>
    </template>

    <template v-slot:no-data>
      <v-btn
        color="primary"
        @click="initialize"
      >
        Reset
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
  import LolService from "../../../services/lol.service"
  import UnitService from "../../../services/unit.service"
  import PartService from "../../../services/part.service"
  import CurveService from "../../../services/curve.service"
  import CustomerService from "../../../services/customer.service"
  import LocationService from "../../../services/location.service"
  import CalibrationService from "../../../services/calibration.service"

  export default {
    data: () => ({
      search: '',
      message: '',
      selected: [],
      loading: false,
      sheet: false,
      tab: null,
      dialogDelete: false,
      dialogNewUnit: false,
      dialogUnassignedUnit: false,
      dialogAddPart: false,
      dialogDeletePart: false,
      dialogCalibration: false,
      dialogDecommissionLol: false,
      dialogManufactureUnit: false,
      dialogCurveHistory: false,
      headers: [
        { text: "LOL Number", align: "start", value: "lolNumber" },
        { text: "LOL Nickname", value: "lolName" },
        { text: "Agent", value: "customer.customerName" },
        { text: "Location", value: "location.locationName" },
        // { text: "Avg. Tests/Month", value: "avgTestsMonth", align: "center" },
        { text: "Actions", value: "actions", align: "center", sortable: false }
      ],
      lols: [],
      dealers: [],
      locations: [],
      units: [],
      unitAddStep: '',
      partShow: 0,
      partEdit: 0,
      unitCreate: {},
      unitUpdate: {},
      unitCalibration: {},
      calibrationData: {},
      calibrationStep: 'initial',
      partCreate: {
        unitID: null,
        partName: null,
        partString: null,
        partMake: null,
        partModel: null,
        partSN: null,
        partNotes: null,
        primary: null,
        curve: {
          curveM: null,
          curveB: null,
        }
      },
      partBeforeEdit: {},
      curveBeforeEdit: {},
      partUpdate: {},
      partDelete: null,
      editedIndex: -1,
      editedPartIndex: 0,
      editedItem: {
        lolNumber: '',
        lolName: null,
        lolNotes: null,
        debugMode: null,
        customerID: null,
        locationID: null,
        unit: {
          unitID: null,
          parts: [
            {
              partID: null,
              partName: null,
              curves: [
                {
                  curveID: null,
                  curveM: null,
                  curveB: null,
                }
              ],
            }
          ]
        }
      },
      defaultItem: {
        lolNumber: '',
        lolName: null,
        lolNotes: null,
        debugMode: null,
        customerID: null,
        locationID: null,
        unit: {
          unitID: null,
          parts: [
            {
              partID: null,
              partName: null,
              curves: [
                {
                  curveID: null,
                  curveM: null,
                  curveB: null,
                }
              ],
            }
          ]
        }
      },
      editMode: false,
      editModeDealer: false,
      rules: {
        required: [
          value => value.length != 0 || 'Required'
        ]
      },
    }),

    computed: {
      currentUser() {
        return this.$store.state.auth.user;
      },
    },

    watch: {},

    created () {
      this.initialize()
    },

    methods: {
      async initialize() {
        this.checkAuth()
        await this.retrieveLols()
        this.retrieveDealers()
        this.retrieveLocations()
        this.retrieveUnassignedUnits()
      },

      checkAuth() {
        if(!this.$route.meta.authorize.includes(this.currentUser.roles.toString())) {
          this.$router.push('/dashboard')
        }
      },

      checkRole(role) {
        if (Array.isArray(role)) {
          var i
          for (i = 0; i < role.length; i++) {
            if (this.currentUser.roles.includes(role[i])) {
              return true
            }
            if (role[i] == 'lf') {
              if (this.currentUser.roles.includes('ROLE_LFADMIN') || this.currentUser.roles.includes('ROLE_LFTECH') || this.currentUser.roles.includes('ROLE_LFBILLING')) {
                return true
              }
            }
            if (role[i] == 'dealer') {
              if (this.currentUser.roles.includes('ROLE_DEALERADMIN') || this.currentUser.roles.includes('ROLE_DEALERTECH')) {
                return true
              }
            }
          }
          return false
        }

        if (role == 'lf') {
          if (this.currentUser.roles.includes('ROLE_LFADMIN') || this.currentUser.roles.includes('ROLE_LFTECH') || this.currentUser.roles.includes('ROLE_LFBILLING')) {
            return true
          }
        }

        if (role == 'dealer') {
          if (this.currentUser.roles.includes('ROLE_DEALERADMIN') || this.currentUser.roles.includes('ROLE_DEALERTECH')) {
            return true
          }
        }

        if (this.currentUser.roles.includes(role)) {
          return true
        } else {
          return false
        }
      },

      async retrieveLols() {
        this.loading = true
        if (this.$route.query.locationid) {
          await LolService.getLocationLols(this.$route.query.locationid)
              .then(async response => {
                this.lols = response.data || []

                return new Promise(resolve => {
                  resolve('Done')
                })
              })
              .catch(e => {
                console.log(e)
                this.snackbar("Error! There was an error retrieving LOLs.", "error", "3000")

                return new Promise(resolve => {
                  resolve('Done')
                })
              })
        } else if (this.$route.query.customerid) {
          await LolService.getCustomerLols(this.$route.query.customerid)
              .then(async response => {
                this.lols = response.data || []

                return new Promise(resolve => {
                  resolve('Done')
                })
              })
              .catch(e => {
                console.log(e)
                this.snackbar("Error! There was an error retrieving LOLs.", "error", "3000")

                return new Promise(resolve => {
                  resolve('Done')
                })
              })
        } else {
          if (this.checkRole('lf')) {
            await LolService.getAll()
              .then(async response => {
                this.lols = response.data || []

                return new Promise(resolve => {
                  resolve('Done')
                })
              })
              .catch(e => {
                console.log(e)
                this.snackbar("Error! There was an error retrieving LOLs.", "error", "3000")

                return new Promise(resolve => {
                  resolve('Done')
                })
              })
          } else {
            await LolService.getCustomerLols(this.currentUser.customerID)
              .then(async response => {
                this.lols = response.data || []

                return new Promise(resolve => {
                  resolve('Done')
                })
              })
              .catch(e => {
                console.log(e)
                this.snackbar("Error! There was an error retrieving LOLs.", "error", "3000")

                return new Promise(resolve => {
                  resolve('Done')
                })
              })
          }

          if (this.$route.query.lolnumber) {
            this.search = this.$route.query.lolnumber
          }
        }

        this.loading = false
      },

      retrieveDealers() {
        CustomerService.getDealers()
        .then(response => {
          this.dealers = response.data || []
        })
        .catch(e => {
          console.log(e)
        })
      },

      retrieveLocations() {
        if (this.$route.query.customerid) {
          LocationService.getCustomerLocations(this.$route.query.customerid)
          .then(response => {
            this.locations = response.data || []
          })
          .catch(e => {
            console.log(e)
          })
        } else {
          LocationService.getAll()
          .then(response => {
            this.locations = response.data || []
          })
          .catch(e => {
            console.log(e)
          })
        }
      },

      async refreshLocations(customerID) {
        var flag = false
        var _this = this
        await LocationService.getCustomerLocations(customerID)
          .then(async response => {
            this.locations = response.data || []
            await this.locations.forEach(forEachLocation)

            async function forEachLocation(item, index) {
              if (_this.editedItem.locationID == item.locationID) {
                flag = true
              }
              return new Promise(resolve => {
                resolve('Done')
              })
            }

            if (flag == false) {
              this.editedItem.locationID = null
            }

            return new Promise(resolve => {
              resolve('Done')
            })
          })
          .catch(e => {
            console.log(e)
          })
      },

      retrieveUnits() {
        UnitService.getAll()
          .then(response => {
            this.units = response.data || []
          })
          .catch(e => {
            console.log(e)
          })
      },

      retrieveUnassignedUnits() {
        UnitService.getUnassigned()
          .then(response => {
            this.units = response.data || []
          })
          .catch(e => {
            console.log(e)
          })
      },

      async retrieveLolUnit(item) {
        await UnitService.getLolUnits(item.lolID)
          .then(async response => {
            item.unit = response.data[0] || {}

            if (item.unit.manufactureDate != null) {
              item.unit.manufactureDateShow = item.unit.manufactureDate.substring(0, 19).replaceAll('-', '/').replace('T', ' ')
            }
            if (item.unit.commissionDate != null) {
              item.unit.commissionDateShow = item.unit.commissionDate.substring(0, 19).replaceAll('-', '/').replace('T', ' ')
            }
            if (item.unit.decommissionDate != null) {
              item.unit.decommissionDateShow = item.unit.decommissionDate.substring(0, 19).replaceAll('-', '/').replace('T', ' ')
            }

            await PartService.getUnitParts(item.unit.unitID)
              .then(async response => {
                if (response.data.length) {
                  item.unit.parts = response.data
                } else {
                  item.unit.parts = [{ partID: null }]
                }

                return new Promise(resolve => {
                  resolve('Done')
                })
              })

            for (const part of item.unit.parts) {
              if (part.installDate != null) {
                part.installDateShow = part.installDate.substring(0, 19).replaceAll('-', '/').replace('T', ' ')
              }
              if (part.commissionDate != null) {
                part.commissionDateShow = part.commissionDate.substring(0, 19).replaceAll('-', '/').replace('T', ' ')
              }
              if (part.decommissionDate != null) {
                part.decommissionDateShow = part.decommissionDate.substring(0, 19).replaceAll('-', '/').replace('T', ' ')
              }

              await CurveService.getPartCurves(part.partID)
                .then(response => {
                  if (response.data.length) {
                    part.curves = response.data
                  } else {
                    part.curves = [{ curveID: null, curveM: null, curveB: null }]
                  }

                  for (const curve of part.curves) {
                    if (curve.createdAt != null) {
                      curve.createdAtShow = curve.createdAt.substring(0, 19).replaceAll('-', '/').replace('T', ' ')
                    }
                  }

                  return new Promise(resolve => {
                    resolve('Done')
                  })
                })
            }

            return new Promise(resolve => {
              resolve('Done')
            })
          })
      },

      async retrieveLolCalibrations(item) {
        await CalibrationService.getLolCalibrations(item.lolID)
          .then(response => {
            var calibration = response.data || []

            if (calibration.length) {
              if (calibration.length > 1) {
                if (calibration[0].completeDate) {
                  item.calibrationDate = new Date(calibration[0].completeDate)
                } else {
                  item.calibrationDate = new Date(calibration[1].completeDate)
                }
              } else {
                if (calibration[0].completeDate) {
                  item.calibrationDate = new Date(calibration[0].completeDate)
                } else {
                  item.calibrationDate = new Date(item.unit.commissionDate)
                }
              }
            } else {
              item.calibrationDate = new Date(item.unit.commissionDate)
            }

            if (item.calibrationDate != null) {
              item.calibrationDate.setFullYear(item.calibrationDate.getFullYear() + 1)
              item.calibrationDateShow = item.calibrationDate.toISOString()
              item.calibrationDateShow = item.calibrationDateShow.substring(0, 10).replaceAll('-', '/')
            } else {
              item.calibrationDateShow = "-----"
            }

            return new Promise(resolve => {
              resolve('Done')
            })
          })
          .catch(e => {
            console.log(e)
            let message = 'There was an error retrieving calibration'
            let color = 'error'
            this.snackbar(message, color, 0)
          })
      },

      createLol() {
        if (this.$route.query.locationid) {
          this.editedItem.locationID = this.$route.query.locationid;
        }
        if (this.$route.query.customerid) {
          this.editedItem.customerID = this.$route.query.customerid;
        }
        LolService.create(this.editedItem)
          .then(response => {
            this.snackbar('The LOL was created successfully', 'success')
            this.editedItem.lolID = response.data.lolID
            this.retrieveLols()
          })
          .catch(e => {
            console.log(e)
          })
      },

      async updateLol() {
        var tempItem = this.editedItem
        var newDealer
        await CustomerService.get(this.editedItem.customerID)
          .then(response => {
            newDealer = response.data || {}

            return new Promise(resolve => {
              resolve('Done')
            })
          })
          .catch(e => {
            console.log(e)
          })

        this.editedItem = tempItem
        if (newDealer.customerName != "Lawrence Factor" && !this.editedItem.commissionDate) {
          this.editedItem.commissionDate = new Date().getTime()
        }

        LolService.update(this.editedItem.lolID, this.editedItem)
          .then(response => {
            window._LOL2P.$emit('SHOW_SNACKBAR', {
              text: 'The LOL was updated successfully',
              color: 'success'
            })
          })
          .catch(e => {
            console.log(e)
          })
      },

      deleteLol() {
        LolService.delete(this.editedItem.lolID)
          .then(response => {
            window._LOL2P.$emit('SHOW_SNACKBAR', {
              text: 'The LOL was deleted successfully',
              color: 'success'
            })
          })
          .catch(e => {
            console.log(e)
          })
      },

      async createUnit() {
        await UnitService.create(this.unitCreate)
          .then(response => {
            this.unitCreate.unitID = response.data.unitID
            // this.unitCreate.parts = [{
            //   partID: null,
            //   curves: [{
            //     curveID: null,
            //     partID: null,
            //     curveM: null,
            //     curveB: null
            //   }]
            // }]

            this.snackbar('The unit waas created successfully', 'success')

            return new Promise(resolve => {
              resolve('Done')
            })
          })
          .catch(e => {
            console.log(e)
          })

        return new Promise(resolve => {
          resolve('Done')
        })
      },

      updateUnit() {
        UnitService.update(this.unitUpdate.unitID, this.unitUpdate)
          .then(response => {
            window._LOL2P.$emit('SHOW_SNACKBAR', {
              text: 'The unit was updated successfully',
              color: 'success'
            })
          })
          .catch(e => {
            console.log(e)
          })
      },

      async createPart() {
        var installDateShow = new Date().toISOString().substring(0, 19).replaceAll('-', '/').replace('T', ' ')
        var newPart = {
          unitID: this.partCreate.unitID,
          partName: this.partCreate.partName,
          partString: this.partCreate.partString,
          partMake: this.partCreate.partMake,
          partModel: this.partCreate.partModel,
          partSN: this.partCreate.partSN,
          partNotes: this.partCreate.partNotes,
          primary: this.partCreate.primary,
          installDate: new Date().getTime(),
          installDateShow: installDateShow,
          curves: [{
            curveID: null,
            curveM: null,
            curveB: null
          }]
        }
        await PartService.create(newPart)
          .then(async response => {
            newPart.partID = response.data.partID
            this.editedItem.unit.parts.push(newPart)
            this.snackbar('Success! The part was added successfully.', 'success', '3000')

            if (this.partCreate.curve.curveM || this.partCreate.curve.curveB) {
              var newCurve = {
                partID: response.data.partID,
                curveM: this.partCreate.curve.curveM,
                curveB: this.partCreate.curve.curveB
              }
              await CurveService.create(newCurve)
                .then(response => {
                  newCurve.curveID = response.data.curveID
                  this.lols[this.editedIndex].unit.parts[this.lols[this.editedIndex].unit.parts.length - 1].curves = [newCurve]

                  return new Promise(resolve => {
                    resolve('Done')
                  })
                })
                .catch(e => {
                  console.log(e)
                })
            }

            return new Promise(resolve => {
              resolve('Done')
            })
          })
          .catch(e => {
            console.log(e)
          })

        return new Promise(resolve => {
          resolve('Done')
        })
      },

      updatePart() {
        PartService.update(this.partUpdate.partID, this.partUpdate)
          .then(response => {
            window._LOL2P.$emit('SHOW_SNACKBAR', {
              text: 'The part was updated successfully',
              color: 'success'
            })
          })
          .catch(e => {
            console.log(e)
          })
      },

      deletePart() {
        PartService.delete(this.partDelete.partID)
          .then(response => {
            window._LOL2P.$emit('SHOW_SNACKBAR', {
              text: 'The part was deleted successfully',
              color: 'success'
            })
          })
          .catch(e => {
            console.log(e)
          })
      },

      createCurve() {
        CurveService.create(this.curveUpdate)
          .then(response => {
            window._LOL2P.$emit('SHOW_SNACKBAR', {
              text: 'The curve was added successfully',
              color: 'success'
            })
          })
          .catch(e => {
            console.log(e)
          })
      },

      updateCurve() {
        CurveService.update(this.partUpdate.curveID, this.partUpdate)
          .then(response => {
            window._LOL2P.$emit('SHOW_SNACKBAR', {
              text: 'The curve was updated successfully',
              color: 'success'
            })
          })
          .catch(e => {
            console.log(e)
          })
      },

      saveUnit () {
        this.unitUpdate = this.editedItem.unit
        if (this.unitUpdate.unitNumber) {
          Object.assign(this.lols[this.editedIndex].unit, this.unitUpdate)
          this.lols.splice(this.editedIndex, 1, this.lols[this.editedIndex])
          this.updateUnit()
        } else {
          this.snackbar("Missing unit info!", "error", "3000")
        }
      },

      newUnitDialog() {
        this.unitCreate = {}
        this.unitCreate.lolID = this.editedItem.lolID
        this.dialogNewUnit = true
      },

      unassignedUnitDialog() {
        this.unitUpdate = {}
        this.dialogUnassignedUnit = true
      },

      newUnitDialogClose() {
        this.unitCreate = {}
        this.dialogNewUnit = false
      },

      unassignedUnitDialogClose() {
        this.unitUpdate = {}
        this.dialogUnassignedUnit = false
      },

      async newUnit () {
        if (this.unitCreate.unitNumber) {
          this.unitCreate.commissionDate = new Date().getTime()
          await this.createUnit()
          Object.assign(this.editedItem.unit, this.unitCreate)
          // Object.assign(this.lols[this.editedIndex].unit, this.unitCreate)
          // this.lols.splice(this.editedIndex, 1, this.lols[this.editedIndex])
          this.tab = 'tab-2'
          this.dialogNewUnit = false
        } else {
          this.snackbar("Missing unit info!", "error", "3000")
        }
      },

      async unassignedUnit () {
        if (this.unitUpdate.unitID) {
          this.unitUpdate.lolID = this.editedItem.lolID
          this.unitUpdate.commissionDate = new Date().getTime()

          await PartService.getUnitParts(this.unitUpdate.unitID)
            .then(async response => {
              if (response.data.length) {
                this.unitUpdate.parts = response.data
              } else {
                this.unitUpdate.parts = [{ partID: null }]
              }

              return new Promise(resolve => {
                resolve('Done')
              })
            })

          for (const part of this.unitUpdate.parts) {
            if (part.installDate != null) {
              part.installDateShow = part.installDate.substring(0, 19).replaceAll('-', '/').replace('T', ' ')
            }
            if (part.commissionDate != null) {
              part.commissionDateShow = part.commissionDate.substring(0, 19).replaceAll('-', '/').replace('T', ' ')
            }
            if (part.decommissionDate != null) {
              part.decommissionDateShow = part.decommissionDate.substring(0, 19).replaceAll('-', '/').replace('T', ' ')
            }

            await CurveService.getPartCurves(part.partID)
              .then(response => {
                if (response.data.length) {
                  part.curves = response.data
                } else {
                  part.curves = [{ curveID: null, curveM: null, curveB: null }]
                }

                for (const curve of part.curves) {
                  if (curve.createdAt != null) {
                    curve.createdAtShow = curve.createdAt.substring(0, 19).replaceAll('-', '/').replace('T', ' ')
                  }
                }

                return new Promise(resolve => {
                  resolve('Done')
                })
              })
          }

          Object.assign(this.lols[this.editedIndex].unit, this.unitUpdate)
          this.lols.splice(this.editedIndex, 1, this.lols[this.editedIndex])
          this.updateUnit()
          this.tab = 'tab-2'
        } else {
          this.snackbar("Missing unit info!", "error", "3000")
        }
        this.dialogUnassignedUnit = false
      },

      addPartDialog() {
        this.partCreate = {
          unitID: this.editedItem.unit.unitID,
          partName: null,
          partString: null,
          partMake: null,
          partModel: null,
          partSN: null,
          partNotes: null,
          primary: null,
          curve: {
            curveM: null,
            curveB: null,
          }
        }
        this.dialogAddPart = true
      },

      addPartDialogClose() {
        this.partCreate = {
          partName: null,
          partString: null,
          partMake: null,
          partModel: null,
          partSN: null,
          partNotes: null,
          primary: null,
          curve: {
            curveM: null,
            curveB: null,
          }
        }
        this.dialogAddPart = false
      },

      addPart () {
        if (!this.partCreate.partName && !this.partCreate.partString && !this.partCreate.partMake && !this.partCreate.partModel && !this.partCreate.partSN && !this.partCreate.partNotes) {
          this.snackbar("Missing part info!", "error", "3000")
        } else {
          this.createPart()
          this.dialogAddPart = false
        }
      },

      showPart(partID) {
        if (this.partShow == partID) {
          this.partShow = 0
          this.partEdit = 0
        } else {
          this.partShow = partID
          this.partEdit = 0
        }
      },

      editPart(index) {
        var partID = this.editedItem.unit.parts[index].partID

        if (this.partEdit == partID) {
          this.partEdit = 0
        } else {
          this.partEdit = partID
          this.partBeforeEdit = {
            unitID: this.editedItem.unit.parts[index].unitID,
            partID: this.editedItem.unit.parts[index].partID,
            partName: this.editedItem.unit.parts[index].partName,
            partString: this.editedItem.unit.parts[index].partString,
            partMake: this.editedItem.unit.parts[index].partMake,
            partModel: this.editedItem.unit.parts[index].partModel,
            partSN: this.editedItem.unit.parts[index].partSN,
            partNotes: this.editedItem.unit.parts[index].partNotes,
            primary: this.editedItem.unit.parts[index].primary,
            installDate: this.editedItem.unit.parts[index].installDate,
            commissionDate: this.editedItem.unit.parts[index].commissionDate,
            decommissionDate: this.editedItem.unit.parts[index].decommissionDate,
            createdAt: this.editedItem.unit.parts[index].createdAt,
            updatedAt: this.editedItem.unit.parts[index].updatedAt,
            curves: this.editedItem.unit.parts[index].curves
          }
          this.curveBeforeEdit = {
            curveID: this.editedItem.unit.parts[index].curves[0].curveID,
            partID: this.editedItem.unit.parts[index].curves[0].partID,
            curveM: this.editedItem.unit.parts[index].curves[0].curveM,
            curveB: this.editedItem.unit.parts[index].curves[0].curveB
          }
        }
      },

      savePart(index) {
        this.partUpdate = this.editedItem.unit.parts[index]
        this.curveUpdate = {
          partID: this.editedItem.unit.parts[index].partID,
          curveM: this.editedItem.unit.parts[index].curves[0].curveM,
          curveB: this.editedItem.unit.parts[index].curves[0].curveB
        }
        this.updatePart()
        if (this.curveUpdate.curveM != this.curveBeforeEdit.curveM || this.curveUpdate.curveB != this.curveBeforeEdit.curveB) {
          this.createCurve()
        }
        this.partEdit = 0
        this.partShow = 0
      },

      undoPart(index) {
        this.editedItem.unit.parts.splice(index, 1, this.partBeforeEdit)
        this.partEdit = 0
      },

      deletePartDialog(index) {
        this.partDelete = this.editedItem.parts[index]
        this.partDelete.index = index
        this.dialogDeletePart = true
      },

      deletePartDialogClose() {
        this.partDelete = null
        this.dialogDeletePart = false
      },

      destroyPart() {
        this.editedItem.parts.splice(this.partDelete.index, 1)
        this.deletePart()
        this.dialogDeletePart = false
      },

      clearSheet() {
        this.editMode = true
        this.editedItem = {
          lolNumber: '',
          lolName: null,
          lolNotes: null,
          debugMode: null,
          customerID: null,
          locationID: null,
          unit: {
            unitID: null,
            parts: [
              {
                partID: null,
                partName: null,
                curves: [
                  {
                    curveID: null,
                    curveM: null,
                    curveB: null,
                  }
                ],
              }
            ]
          }
        }
        this.editedIndex = -1
        this.tab = 1
      },

      async editItem (item) {
        this.loading = true
        this.editMode = false
        await this.retrieveLolUnit(item)
        await this.retrieveLolCalibrations(item)

        if (item.lastPowerOn != null) {
          item.lastPowerOnShow = item.lastPowerOn.substring(0, 19).replaceAll('-', '/').replace('T', ' ')
        }
        if (item.lastSync != null) {
          item.lastSyncShow = item.lastSync.substring(0, 19).replaceAll('-', '/').replace('T', ' ')
        }
        if (item.commissionDate != null) {
          item.commissionDateShow = item.commissionDate.substring(0, 19).replaceAll('-', '/').replace('T', ' ')
        }
        if (item.decommissionDate != null) {
          item.decommissionDateShow = item.decommissionDate.substring(0, 19).replaceAll('-', '/').replace('T', ' ')
        }

        this.editedIndex = this.lols.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.refreshLocations(this.editedItem.customerID)
        this.sheet = true
        this.tab = 'tab-1'
        this.loading = false
      },

      deleteItem (item) {
        this.editedIndex = this.lols.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        this.lols.splice(this.editedIndex, 1)
        this.deleteLol();
        this.closeDelete()
      },

      close () {
        this.sheet = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
        if (!this.editedItem.lolNumber) {
          this.snackbar('Missing LOL Number', 'error')
        } else {
          if (this.editedIndex > -1) {
            Object.assign(this.lols[this.editedIndex], this.editedItem);
            this.updateLol()
          } else {
            this.lols.push(this.editedItem)
            this.createLol()
          }
          // this.close()
        }
      },

      editModeToggle(toggle) {
        if (toggle) {
          if (this.checkRole('lf')) {
            this.editMode = true
          } else {
            this.editModeDealer = true
          }
        } else {
          this.editMode = false
          this.editModeDealer = false
        }
      },

      openCalibrationDialog() {
        this.dialogCalibration = true
      },

      async performCalibration() {
        this.unitCalibration.lolID = this.editedItem.lolID
        this.calibrationData.lolID = this.editedItem.lolID
        this.calibrationData.beforeUnitID = this.editedItem.unit.unitID
        this.calibrationData.calibrationDate = new Date().getTime()
        let d = new Date();
        let n = d.toJSON();
        let ymd = n.substring(0, 10).replace(/-/g,"");
        let hmsm = n.substring(11, 23).replace(/:/g,"").replace(".","")
        this.calibrationData.calibrationNumber = ymd + hmsm

        if (this.calibrationStep.includes('Unassigned')) {
          this.calibrationData.afterUnitID = this.unitCalibration.unitID

          UnitService.update(this.unitCalibration.unitID, this.unitCalibration)
            .then(response => {
              this.snackbar("Success! The unit was assigned successfully","success")
            })
            .catch(e => {
              console.log(e)
            })
        } else if (this.calibrationStep.includes('New')) {
          await UnitService.create(this.unitCalibration)
            .then(response => {
              this.snackbar("Success! The unit was created successfully","success")
              this.calibrationData.afterUnitID = response.data.unitID

              return new Promise(resolve => {
                resolve('Done')
              })
            })
            .catch(e => {
              console.log(e)
            })
        } else {
          this.calibrationData.afterUnitID = this.editedItem.unit.unitID
        }

        CalibrationService.create(this.calibrationData)
          .then(response => {
            this.snackbar("Success! The calibration was performed successfully","success")
            this.sheet = false
            this.retrieveLols()
          })
          .catch(e => {
            console.log(e);
          });

        this.calibrationStep = 'initial'
        this.dialogCalibration = false
      },

      decommissionLol() {
        if (!this.editedItem.decommissionDate) {
          var decommissionDate = new Date().getTime()
          var updateLol = { decommissionDate: decommissionDate }
          LolService.update(this.editedItem.lolID, updateLol)
            .then(response => {
              this.snackbar('Success! LOL successfully decommissioned', 'success')
              this.dialogDecommissionLol = false
              this.sheet = false
              this.retrieveLols()
            })
            .catch(e => {
              console.log(e)
              this.snackbar('Error! There was an error decommissioning LOL', 'error', 0)
            })
        }
      },

      manufactureUnit() {
        if (!this.editedItem.unit.manufactureDate) {
          var manufactureDate = new Date().getTime()
          var updateUnit = { manufactureDate: manufactureDate }
          UnitService.update(this.editedItem.unit.unitID, updateUnit)
            .then(response => {
              this.snackbar('Success! Unit successfully marked as manufactured', 'success')
              this.dialogManufactureUnit = false
              this.sheet = false
              this.retrieveLols()
            })
            .catch(e => {
              console.log(e)
              this.snackbar('Error! There was an error marking Unit as manufactured', 'error', 0)
            })
        }
      },

      openCurveHistoryDialog(index) {
        this.editedPartIndex = index
        this.dialogCurveHistory = true
      },

      snackbar(message, color, timeout) {
        window._LOL2P.$emit('SHOW_SNACKBAR', {
          text: message,
          color: color,
          timeout: timeout
        })
      },
    },
  }
</script>